import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

import WidgetContainer from "components/WidgetContainer/WidgetContainer";

import "./SecurityOverviewWidget.css";
const SecurityOverviewWidget = () => {
    const data = useStaticQuery(graphql`
        query SecurityOverviewWidgetQuery {
            mobileImage: file(relativePath: { eq: "1in5-mobile.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopImage: file(relativePath: { eq: "1in5-desktop.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
        }
    `);

    const sources = [
        data.desktopImage.childImageSharp.fluid,
        {
            ...data.mobileImage.childImageSharp.fluid,
            media: `(max-width: 600px)`,
        },
    ];

    return (
        <WidgetContainer>
            <div className="security-overview">
                <div className="security-overview__img-container">
                    <Img
                        fluid={sources}
                        alt="Car Insurance cover on PhonePe"
                        imgStyle={{
                            objectFit: "contain",
                            height: "100%",
                        }}
                    />
                </div>
                <div className="security-overview__content">
                    <div className="security-overview__content__img-container">
                        <Img
                            fluid={sources}
                            alt="Car Insurance cover on PhonePe"
                            imgStyle={{
                                objectFit: "contain",
                                height: "100%",
                            }}
                        />
                    </div>
                    <p className="security-overview__content__introtext">
                        That’s why we have an advanced security infrastructure
                        to keep your transactions safe. We do what it takes to
                        earn the trust that you and 25 crore Indians have placed
                        in us.
                    </p>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default SecurityOverviewWidget;
